module.exports = __webpack_public_path__ + "static/media/hero_kenia_getty_mobile.9c015c63.jpg";